import { observer } from 'mobx-react-lite';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';

const styles = require('./UpNextV2Event.scss');

export interface UpNextEventProps {
    eventCountString: string;
    eventName: string;
    eventLocation: string;
    timeUntilEvent: string;
}

export default observer(function UpNextV2Event(props: UpNextEventProps) {
    return (
        <div className={styles.upNextEventContainer}>
            {props.eventCountString && (
                <div className={styles.conflictingEventsCount}>{props.eventCountString}</div>
            )}
            <Icon className={styles.eventIconColumn} iconName={ControlIcons.Event} />
            <div className={styles.eventDetailsColumn}>
                <div className={styles.eventName}>{props.eventName}</div>
                <div className={styles.eventTimeLocationRow}>
                    <div className={styles.eventTime}>{props.timeUntilEvent}</div>
                    {props.eventLocation && (
                        <div className={styles.eventLocation}>{props.eventLocation}</div>
                    )}
                </div>
            </div>
        </div>
    );
});
